import {
  FieldElement,
  LayoutBreakpoints,
  LayoutElement,
} from "@entaconsulting/form";
import { isNumber, set } from "lodash";
import findBiggestElement from "./findBiggestElement";
import getElementSize from "./getElementSize";
import reduceSizeByBreakpoint from "./reduceSizeByBreakpoint";

const generatePlaceForNewElement = (
  newElementSize: number,
  elements: LayoutElement[],
  insertAt: number,
  rowStart: number,
  rowEnd: number,
  activeBreakpoint: NonNullable<LayoutBreakpoints>
): Record<string, any> => {
  const elementsInRow: number = rowEnd - rowStart + 1;
  let unavailableSpace: number = 0;
  let modifieds: Record<string, FieldElement> = {};

  if (elementsInRow >= 12) return {};

  for (let i = rowStart; i <= rowEnd; i++) {
    unavailableSpace += getElementSize(elements[i], activeBreakpoint);
  }

  let availableSpace = 12 - unavailableSpace;
  let spaceToGenerate = newElementSize - availableSpace;

  while (spaceToGenerate > 0) {
    let { element, index } = findBiggestElement(
      elements,
      insertAt,
      rowStart,
      rowEnd,
      modifieds,
      activeBreakpoint
    );
    if (element && isNumber(index)) {
      modifieds[index] = Object.assign({}, element);
      const newSize = reduceSizeByBreakpoint(modifieds[index]);
      set(modifieds[index], "size", newSize);
      spaceToGenerate--;
    }
  }

  return modifieds;
};

export default generatePlaceForNewElement;
